// const BASE_URL = "http://localhost:8080"
const BASE_URL = "https://show-box.onrender.com"
export default BASE_URL